import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

interface PendingCreditOperation {
  id: string;
  amount: number;
  timestamp: number;
  type: "deduction" | "addition";
}

interface PendingCreditsState {
  operations: PendingCreditOperation[];
  totalPendingDeductions: number;
}

const initialState: PendingCreditsState = {
  operations: [],
  totalPendingDeductions: 0,
};

export const { actions, reducer } = createSlice({
  name: "pendingCredits",
  initialState,
  reducers: {
    flush() {
      return initialState;
    },
    addPendingDeduction(state, action: PayloadAction<{ id: string; amount: number }>) {
      const operation: PendingCreditOperation = {
        id: action.payload.id,
        amount: action.payload.amount,
        timestamp: Date.now(),
        type: "deduction",
      };

      state.operations.push(operation);
      state.totalPendingDeductions += action.payload.amount;
    },
    removePendingOperation(state, action: PayloadAction<string>) {
      const operationIndex = state.operations.findIndex((op) => op.id === action.payload);
      if (operationIndex !== -1) {
        const operation = state.operations[operationIndex];
        if (operation.type === "deduction") {
          state.totalPendingDeductions -= operation.amount;
        }
        state.operations.splice(operationIndex, 1);
      }
    },
    clearExpiredOperations(state, action: PayloadAction<number>) {
      const expirationTime = action.payload;
      const expiredOperations = state.operations.filter((op) => op.timestamp < expirationTime);

      expiredOperations.forEach((op) => {
        if (op.type === "deduction") {
          state.totalPendingDeductions -= op.amount;
        }
      });

      state.operations = state.operations.filter((op) => op.timestamp >= expirationTime);
    },
    clearAllPendingOperations(state) {
      state.operations = [];
      state.totalPendingDeductions = 0;
    },
  },
});

export default reducer;
